/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Rcnv_RoleInputs */

const es_landing_rcnv_role = /** @type {(inputs: Landing_Rcnv_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Director deportivo — RCNV`)
};

const gl_landing_rcnv_role = /** @type {(inputs: Landing_Rcnv_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Director deportivo — RCNV`)
};

const en_landing_rcnv_role = /** @type {(inputs: Landing_Rcnv_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports director — RCNV`)
};

/**
* | output |
* | --- |
* | "Sports director — RCNV" |
*
* @param {Landing_Rcnv_RoleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_rcnv_role = /** @type {((inputs?: Landing_Rcnv_RoleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Rcnv_RoleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_rcnv_role(inputs)
	if (locale === "en") return en_landing_rcnv_role(inputs)
	return es_landing_rcnv_role(inputs)
});